export default __webpack_public_path__ + "static/media/sad.b154f153.png";